import React, { useState } from 'react';
import { MerchandiserStandardView } from './MerchandiserStandardView';
import { MerchandiserExpertView } from './MerchandiserExpertView';
import { Box, Stack, styled, Switch, Typography } from '@mui/material';
import { getPolyglot } from '../../../../i18n';
import { ExpertViewIcon } from '../../theme/icons';
import { Merchandiser } from '../../redux/composableDevice/model/Merchandiser.model';

const MerchandiserDetail = ({
  merchandiser,
}: {
  merchandiser: Merchandiser;
}) => {
  const polyglot = getPolyglot();
  const [selectedView, setSelectedView] = useState('standard');

  let content = <MerchandiserExpertView merchandiser={merchandiser} />;

  if (selectedView === 'standard') {
    content = <MerchandiserStandardView merchandiser={merchandiser} />;
  }

  return (
    <Stack sx={{ padding: '0rem', width: '100%' }}>
      <Box
        sx={{
          backgroundColor: (theme) =>
            selectedView === 'expert'
              ? theme.palette.common.black
              : theme.palette.primary.dark,
          color: (theme) => theme.palette.common.white,
          margin: '0 0 1rem 0',
          borderRadius: '0.5rem 0.5rem 0 0',
          textAlign: 'center',
          padding: '0 0.5rem',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography variant="caption" fontSize={'1rem'} sx={{ flexGrow: 1 }}>
          {polyglot.t(`freshwatch.merchandiser.${selectedView}_view`)}
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <ExpertViewIcon />
          <StyledSwitch
            sx={{ justifySelf: 'flex-end' }}
            checked={selectedView === 'expert'}
            onClick={() =>
              setSelectedView((state) =>
                state === 'expert' ? 'standard' : 'expert'
              )
            }
          />
        </Box>
      </Box>

      {content}
    </Stack>
  );
};

export default MerchandiserDetail;

const StyledSwitch = styled(Switch)(({ theme, checked }) => ({
  padding: 7,
  '& .MuiSwitch-switchBase': {
    '&.Mui-checked': {
      color: theme.palette.common.white,
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: checked
          ? theme.palette.common.white
          : theme.palette.primary.dark,
      },
    },
  },
  '& .Mui-checked+.MuiSwitch-track': {
    backgroundColor: theme.palette.common.white,
    opacity: 1,
  },
  '& .MuiSwitch-track': {
    borderRadius: 22 / 2,
    backgroundColor: theme.palette.common.white,
    opacity: 1,
    '&::before, &::after': {
      transform: 'translateY(-50%)',
    },
    '&::before': {
      left: 12,
    },
    '&::after': {
      right: 12,
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: 'none',
    width: 16,
    height: 16,
    margin: 2,
    color: theme.palette.common.white,
    backgroundColor: checked
      ? theme.palette.common.black
      : theme.palette.primary.dark,
  },
}));
